import { render } from "./TheReleaseStationsList.vue?vue&type=template&id=512b987b"
import script from "./TheReleaseStationsList.vue?vue&type=script&lang=js"
export * from "./TheReleaseStationsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__